(function () {
  const root = document.querySelector('[data-product-page]');
  if (!root) return;

  const mainImg = root.querySelector('[data-gallery-main]');
  const thumbs = root.querySelectorAll('[data-gallery-thumb]');
  const prevBtn = root.querySelector('[data-gallery-prev]');
  const nextBtn = root.querySelector('[data-gallery-next]');
  let activeIndex = 0;

  function setActive(index) {
    if (!thumbs.length || !mainImg) return;
    activeIndex = (index + thumbs.length) % thumbs.length;
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === activeIndex);
    });
    const src = thumbs[activeIndex].dataset.fullSrc;
    const alt = thumbs[activeIndex].dataset.alt || '';
    if (src) {
      mainImg.src = src;
      mainImg.alt = alt;
    }
  }

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => setActive(i));
  });

  prevBtn?.addEventListener('click', () => setActive(activeIndex - 1));
  nextBtn?.addEventListener('click', () => setActive(activeIndex + 1));

  const qtyInput = root.querySelector('[data-qty-input]');
  root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    if (!qtyInput) return;
    const val = Math.max(1, parseInt(qtyInput.value, 10) - 1);
    qtyInput.value = val;
  });
  root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    if (!qtyInput) return;
    const val = parseInt(qtyInput.value, 10) + 1;
    qtyInput.value = val;
  });

  const buyNowBtn = root.querySelector('[data-buy-now]');
  const productForm = root.querySelector('.gh-pdp__form');
  buyNowBtn?.addEventListener('click', async (e) => {
    e.preventDefault();
    if (!productForm) return;
    const formData = new FormData(productForm);
    try {
      await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });
      window.location.href = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}checkout` : '/checkout';
    } catch (err) {
      productForm.submit();
    }
  });

  const countdown = root.querySelector('[data-countdown]');
  const endDate = countdown?.dataset.end;
  if (countdown && endDate) {
    const units = {
      days: countdown.querySelector('[data-unit="days"]'),
      hours: countdown.querySelector('[data-unit="hours"]'),
      mins: countdown.querySelector('[data-unit="mins"]'),
      secs: countdown.querySelector('[data-unit="secs"]'),
    };

    function tick() {
      const diff = new Date(endDate).getTime() - Date.now();
      if (diff <= 0) {
        countdown.closest('.gh-pdp__sale')?.remove();
        return;
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      if (units.days) units.days.textContent = String(d).padStart(2, '0');
      if (units.hours) units.hours.textContent = String(h).padStart(2, '0');
      if (units.mins) units.mins.textContent = String(m).padStart(2, '0');
      if (units.secs) units.secs.textContent = String(s).padStart(2, '0');
    }

    tick();
    setInterval(tick, 1000);
  }

  const tabBtns = document.querySelectorAll('[data-tab-btn]');
  const tabPanels = document.querySelectorAll('[data-tab-panel]');
  tabBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.tabBtn;
      tabBtns.forEach((b) => b.classList.toggle('is-active', b === btn));
      tabPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.tabPanel === id);
      });
    });
  });

  // Sync Reviews tab count from Judge.me badge when available
  const reviewsTab = document.querySelector('[data-reviews-tab]');
  if (reviewsTab) {
    const label = reviewsTab.dataset.reviewsLabel || 'Reviews';
    const applyCount = (count) => {
      if (!count && count !== 0) return;
      reviewsTab.textContent = `${label} (${count})`;
    };

    const readJudgeMeCount = () => {
      const badge = document.querySelector('.jdgm-prev-badge__text, .jdgm-preview-badge');
      if (!badge) return null;
      const match = badge.textContent.match(/\((\d+)\)|\b(\d+)\s+(?:review|beoordeling)/i);
      if (!match) return null;
      return Number(match[1] || match[2]);
    };

    const sync = () => {
      const count = readJudgeMeCount();
      if (count !== null) applyCount(count);
    };

    sync();
    const observer = new MutationObserver(sync);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    setTimeout(() => observer.disconnect(), 10000);
  }
})();
